import { render, staticRenderFns } from "./recordListModal.vue?vue&type=template&id=2990a53e&scoped=true&"
import script from "./recordListModal.vue?vue&type=script&lang=js&"
export * from "./recordListModal.vue?vue&type=script&lang=js&"
import style0 from "./recordListModal.vue?vue&type=style&index=0&id=2990a53e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2990a53e",
  null
  
)

export default component.exports